import { createElement } from "@/utils/create-elem.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import "@/styles/components/board.scss";
import { appState } from "@/utils/state.js";
import { userClick } from "@/core/userClick.js";

export function cells(parent) {
  const size = (appState.getState("levelInd") + 1) * 5;
  const boardArr = [];
  let cell;

  const cells = createElement({
    tag: "div",
    classes: ["game-board", "board__item"],
    style: `grid-template-rows: repeat(${size}, 1fr);`,
    parent: parent,
  });

  for (let row = 0; row < size; row++) {
    const rowElement = createElement({
      tag: "div",
      classes: ["row"],
      style: `grid-template-columns: repeat(${size}, 1fr);`,
      parent: cells,
    });
    for (let col = 0; col < size; col++) {
      cell = createElement({
        tag: "div",
        classes: ["cell"],
        parent: rowElement,
      });
      boardArr.push(cell);
    }
  }
  boardArr.forEach((cell) => {
    cell.addEventListener("mousedown", (event) => {
      eventEmitter.emit("userClick", { e: event, i: boardArr.indexOf(cell) });
    });
  });

  eventEmitter.clear("userClick");
  userClick();
}
